module.exports = __webpack_public_path__ + "static/media/blender-phone.8da58fa6.svg";